<app-server-grid [configuration]="configuration" [(request)]="request" [views]="views" [refreshViews]="refreshViews"
  [(selection)]="selection" [actions]="actions" [isLoadOnInit]="false" [refresh]="refreshGrid"
  [filterTemplate]="filterForm" [filterHeaderText]="filterHeaderText" [filterFooterText]="filterFooterText"
  [isMemberFilterValid]="isMemberFilterValid" [isMemberQuery]="isMemberQuery" [onlyChartsInput]="onlyChartsInput"
  (memberChartEmit)="memberChartEmit($event)">

  <ng-template #memberIdColumn let-rowData>
    <app-member-grid-member-id [data]="rowData" [masterMemberIdRouteUrl]="masterMemberIdRouteUrl" [showMemberWithCharts]="showMemberWithCharts">
    </app-member-grid-member-id>
  </ng-template>

  <ng-template #filterForm let-form>
    <form [formGroup]="form" class="ui-modal-width" #memberForm="ngForm">
      <app-tab-menu orientation="left">

        <app-tab-panel class="checkbox-group__halves" header="Project" [selected]="selectProjectTab">
          <div class="p-col-12 p-md-12 p-lg-12">
            <form-factory [formGroup]="form" [model]="projectsInput"></form-factory>
          </div>
        </app-tab-panel>

        <app-tab-panel header="Member" [selected]="!selectProjectTab">
          <div class="p-col-12 p-md-12 p-lg-12">
            <form-factory [formGroup]="form" [model]="memberFirstNameInput"></form-factory>
            <form-factory [formGroup]="form" [model]="memberLastNameInput"></form-factory>
            <form-factory [formGroup]="form" [model]="memberDobInput" (onChange)="formatMemberDobDate()"></form-factory>
            <form-factory [formGroup]="form" [model]="reveleerMemberIndexInput"></form-factory>
            <form-factory [formGroup]="form" [model]="memberIdInput"></form-factory>
            <form-factory [formGroup]="form" [model]="memberKeyInput"></form-factory>
            <form-factory [formGroup]="form" [model]="memberStatusInput"></form-factory>
          </div>
        </app-tab-panel>
      </app-tab-menu>
    </form>
  </ng-template>
</app-server-grid>
